import(/* webpackMode: "eager" */ "/app/src/app/(public)/hotels/loading.tsx");
